import { render, staticRenderFns } from "./genOrg.vue?vue&type=template&id=76f9256b&scoped=true&"
import script from "./genOrg.vue?vue&type=script&lang=js&"
export * from "./genOrg.vue?vue&type=script&lang=js&"
import style0 from "./genOrg.vue?vue&type=style&index=0&id=76f9256b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f9256b",
  null
  
)

export default component.exports